import { render, staticRenderFns } from "./DiscountConnectionApprovedPage.vue?vue&type=template&id=de55cd26&scoped=true&"
import script from "./DiscountConnectionApprovedPage.vue?vue&type=script&lang=js&"
export * from "./DiscountConnectionApprovedPage.vue?vue&type=script&lang=js&"
import style0 from "./DiscountConnectionApprovedPage.vue?vue&type=style&index=0&id=de55cd26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de55cd26",
  null
  
)

export default component.exports